import React, {useState, useEffect} from 'react';
import { Row, Col } from '../../bootstrap/index.jsx';
import Help from "../../common/Help.jsx";
import ToggleSwitch, {TextOptionElem} from "../../common/ToggleSwitch.jsx";

const DisaggregationFormFields = ({disaggregations, readOnly, indicator, updateIndicator, mayDefinePartialDisaggregations}) => {

  const [data, setData] = useState(disaggregations || [])

  useEffect(() => {

    data.map((d, di) => {
      var nulls = d.categories.some(function (el) {
        return el.target == null || el.baseline == null;
      })
      if (!nulls) {
        toggleUseTargets(di)
      }
    })
  }, [])

  function addDis(e) {
    e.preventDefault();
    setData(data.concat({id: 0, title: "", useTargets: false, categories: [{id: 0, title: "", baseline: "", target: ""}]}))
  }

  function addCat(e, id) {
    e.preventDefault();
    var newData = data
    newData[id].categories.push({id: 0, title: "", baseline: "", target: ""})
    setData([...newData]) // Use spreading so react re-renders
  }

  function removeDis(e, id) {
    e.preventDefault();
    var newData = data
    newData.splice(id, 1)
    setData([...newData])
  }

  function removeCat(e, parentIndex, id) {
    e.preventDefault();
    var newData = data
    newData[parentIndex].categories.splice(id, 1)
    setData([...newData])
  }

  function updateTitle(title, id, parentIndex) {
    if (parentIndex != null) {
      var newData = data
      newData[parentIndex].categories[id].title = title
      setData([...newData])
    } else {
      var newData = data
      newData[id].title = title
      setData([...newData])
    }
  }

  function toggleUseTargets(id) {
    var newData = data;
    newData[id].useTargets = !data[id].useTargets
    setData([...newData])
  }

  function toggleDisaggregationType() {
    updateIndicator('disaggregation_type', indicator.disaggregation_type == 'strict' ? 'lax' : 'strict')
  }

  function updateBaseline(value, id, parentIndex) {
    var newData = data
    newData[parentIndex].categories[id].baseline = value
    setData([...newData])
    
  }

  function updateTarget(value, id, parentIndex) {
    var newData = data
    newData[parentIndex].categories[id].target = value
    setData([...newData])
  }

  return (
    <Row className="form-group">
      <Col className="indicator-disaggregation-container">
        <Row>
          <Col>
            <label>
              {I18n.t('disaggregation')}
              <Help text={I18n.t("indicator_add_disaggregation_help")} />
              <p>
                <small className="text-muted">{I18n.t('indicator_disaggregations_instruction')}</small>
              </p>
            </label>
          </Col>
        </Row>
        <Row>
          <Col>              
            <label>{I18n.t('use_full_disaggregation')}</label>
            <Help text={I18n.t("strict_lax_help")} />
          </Col>

          <Col size='xs-3' >
            {readOnly || !mayDefinePartialDisaggregations ? (indicator.disaggregation_type == 'lax' ? I18n.t('option_no') : I18n.t('option_yes')) : <ToggleSwitch 
                isOn={indicator.disaggregation_type != 'lax'} 
                handleToggle={toggleDisaggregationType} 
                name={'disaggregation_type'}
                yesElem={<TextOptionElem text={I18n.t('option_yes').toUpperCase()}/>}
                noElem={<TextOptionElem text={I18n.t('option_no').toUpperCase()} side='right' />}
                style={{width: 50}}
                includeFalse={true}
                checkedValue='strict'
                uncheckedValue='lax'
              />
            }
          </Col>
        </Row>

        {data != [] && data.map((v, i) => {
          return <Dimension 
            dimData={v}
            index={i} 
            key={'dimension-' + i}
            addCat={addCat}
            removeDis={removeDis}
            removeCat={removeCat}
            updateTitle={updateTitle}
            toggleUseTargets={toggleUseTargets}
            toggleDisaggregationType={toggleDisaggregationType}
            updateTarget={updateTarget}
            updateBaseline={updateBaseline}
            readOnly={readOnly}
          />
        })}

        {readOnly ? null : <div className='form-group row' >
          <div className='col-xs-12' >
            <button className='pull-right btn btn-primary new-disaggregation' onClick={addDis}>
              <span className='icon icon-add' ></span>
              { ' ' + I18n.t('add_disaggregation')}
            </button>
          </div>
        </div>}

        <input type="hidden" name="disaggregation_state" value={JSON.stringify(data)} />
        <hr/>
      </Col>
    </Row>
  );
}


const Dimension = ({index, addCat, removeDis, removeCat, updateTitle, toggleUseTargets, toggleDisaggregationType, dimData, updateTarget, updateBaseline, readOnly}) => {
  return (
    <div className='indicator-disaggregation-dimension'>
      
      <div className='row'>
        <div className='col-xs-12'>
        <label>
          {I18n.t('dimension')}
        </label>
        </div>
      </div>

      <div className='row' >

        <div className='col-xs-11' >
          <input name={"disaggregations[" + index + "][root][title]"} value={dimData.title} onChange={ (e) => updateTitle(e.target.value, index, null) } className='col-xs-1 form-control' placeholder={I18n.t('dimension')} readOnly={readOnly}></input>
        </div>
        <div className='col-xs-1' >
          {readOnly ? null : <>
            <button className="pull-right btn btn-danger remove-disaggregation small-remove-button" onClick={ (e) => removeDis(e, index) }>
              <span className='icon icon-trash' ></span>
            </button>
          </>}
        </div>

        <div>
          <input name={"disaggregations[" + index + "][root][id]"} value={dimData.id} type="hidden"/>
        </div>
      </div>
      <div className='row mt-1'>
        <div className='col-xs-12' >
          <div className='row'>
            <div className='col-xs-3' >
              <div className='use-targets'>{I18n.t('use_targets')}</div>
            </div>  
          </div>
          <div className='row'>
            <div className='col-xs-3' >
              {readOnly ?
                <>
                  {I18n.t(dimData.useTargets ? 'option_yes' : 'option_no')}
                  {dimData.useTargets ? <input type="hidden" name={'disaggregations[' + index + '][root][useTargets]'} value={1} /> : null}
                </>
                : <ToggleSwitch 
                    isOn={dimData.useTargets || false} 
                    handleToggle={ () => { toggleUseTargets(index) } } 
                    name={'disaggregations[' + index + '][root][useTargets]'}
                    style={{width: 50}}
                    yesElem={<TextOptionElem text={I18n.t('option_yes').toUpperCase()}/>}
                    noElem={<TextOptionElem text={I18n.t('option_no').toUpperCase()} side='right' />}
    
                  />
              }              
            </div>  
          </div>
        </div>
      </div>

      {dimData.categories.sort((a,b) => {
        if (a.id !== 0 && b.id !== 0) {
          return a.id - b.id
        }
        return 0
      }).map((v, i) => {
        return <Category  
          index={i}
          key={'category-' + i}
          catData={v}
          removeCat={removeCat}
          parentIndex={index}
          updateTitle={updateTitle}
          useTargets={dimData.useTargets}
          updateTarget={updateTarget}
          updateBaseline={updateBaseline}
          readOnly={readOnly}
        />
      })}

      {readOnly ? null : <div className='row'>
        <div className='col-xs-4 add-category-button' >
          <button className="btn btn-primary btn-sm " onClick={ (e) => addCat(e, index) }>
          <span className='icon icon-add'></span>
            { ' ' + I18n.t('add_disaggregation_category')}
          </button>
        </div>
        <div className='col-xs-4'></div>
      </div>}
    </div>
  );
}


const Category = ({index, removeCat, parentIndex, updateTitle, catData, useTargets, updateTarget, updateBaseline, readOnly}) => {

  return (
    <div className='disaggregation-categories'>

      <div className='row indicator-disaggregation-category'  >

        <div className='col-xs-3' >
          <label>
            { I18n.t('category') + ' ' + (index + 1) }
          </label>
        </div>

        <div className="col-xs-8" >
          <input name={"disaggregations[" + parentIndex + "][" + index + "][title]"} value={catData.title} onChange={ (e) => updateTitle(e.target.value, index, parentIndex) } className='form-control'  placeholder={I18n.t('category')} readOnly={readOnly}></input>
        </div>

        <div>
          <input name={"disaggregations[" + parentIndex + "][" + index + "][id]"} value={catData.id} type="hidden"/>
        </div>

        <div className="col-xs-1" >
          {readOnly ? null : <>
            <button className="pull-right btn btn-danger remove-disaggregation small-remove-button" onClick={ (e) => removeCat(e, parentIndex, index) }>
              <span className='icon icon-trash' ></span>
            </button>
          </>}
        </div>

      </div>

      {useTargets &&
        <div>
          
          <div className='row indicator-disaggregation-category'  >

            <div className='col-xs-3' >
              <div className='normal-label' >
              {I18n.t('baseline_value')}
              </div>
            </div>

            <div className="col-xs-4" >
              <input name={"disaggregations[" + parentIndex + "][" + index + "][baseline]"} value={catData.baseline} onChange={ (e) => updateBaseline(e.target.value, index, parentIndex) } className='form-control'  placeholder={I18n.t('baseline_value')}></input>
            </div>

          </div>

          <div className='row indicator-disaggregation-category'  >

            <div className='col-xs-3' >
              <div className='normal-label'>
                {I18n.t('target_value')}
              </div>
            </div>

            <div className="col-xs-4" >
              <input name={"disaggregations[" + parentIndex + "][" + index + "][target]"} value={catData.target} onChange={ (e) => updateTarget(e.target.value, index, parentIndex) } className='form-control'  placeholder={I18n.t('target_value')}></input>
            </div>

          </div>
        </div>
        
      }

    </div>
  );
}







export default DisaggregationFormFields;